import React from "react";
import { Modal, Descriptions, Typography, Button, message, Empty } from "antd";
import { ChatHistoryItem, ChatMessage } from "../../../../types/dataControl";
import ReactMarkdown from "react-markdown";

const { Text, Title: AntTitle } = Typography;

interface ChatDetailModalProps {
  visible: boolean;
  data: ChatHistoryItem | null;
  onClose: () => void;
}

const ChatDetailModal: React.FC<ChatDetailModalProps> = ({
  visible,
  data,
  onClose,
}) => {
  if (!data) return null;

  const handleCopy = () => {
    const messages = data.message?.messages || [];
    navigator.clipboard.writeText(
      messages.map((msg) => `${msg.role}: ${msg.content}`).join("\n\n")
    );
    message.success("聊天记录已复制到剪贴板");
  };

  // 渲染聊天消息
  const renderChatMessages = (messages: ChatMessage[]) => {
    return messages.map((message, index) => {
      const isUser = message.role === "user";

      return (
        <div
          key={index}
          style={{
            margin: "16px 0",
            display: "flex",
            flexDirection: isUser ? "row-reverse" : "row",
            alignItems: "flex-start",
          }}
        >
          {/* 头像 */}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: isUser ? "#1890ff" : "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              marginRight: isUser ? 0 : 12,
              marginLeft: isUser ? 12 : 0,
              flexShrink: 0,
            }}
          >
            <i className={isUser ? "ri-user-line" : "ri-bard-line"} />
          </div>

          {/* 消息内容 */}
          <div style={{ maxWidth: "80%" }}>
            {/* 消息发送者 */}
            <div
              style={{
                fontSize: "12px",
                color: "#8c8c8c",
                marginBottom: "4px",
                textAlign: isUser ? "right" : "left",
              }}
            >
              {isUser ? "用户" : "HongMo AI"}
            </div>

            {/* 消息气泡 */}
            <div
              style={{
                padding: "12px 16px",
                borderRadius: "12px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                backgroundColor: isUser ? "#E6F7FF" : "#F6FFED",
                border: isUser ? "1px solid #BAE7FF" : "1px solid #D9F7BE",
                position: "relative",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {message.role === "assistant" ? (
                <ReactMarkdown>{message.content}</ReactMarkdown>
              ) : (
                message.content
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <i
            className="ri-message-3-line"
            style={{ color: "#1677ff", marginRight: 8 }}
          />
          聊天记录详情
        </div>
      }
      open={visible}
      onCancel={onClose}
      width={800}
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
        <Button
          key="copy"
          type="default"
          icon={<i className="ri-file-copy-line" />}
          onClick={handleCopy}
        >
          复制聊天记录
        </Button>,
      ]}
    >
      <div style={{ maxHeight: "70vh", overflow: "auto" }}>
        <Descriptions
          bordered
          column={1}
          size="small"
          style={{ marginBottom: 20 }}
        >
          <Descriptions.Item label="ID">{data.id}</Descriptions.Item>
          <Descriptions.Item label="用户ID">{data.open_id}</Descriptions.Item>
          <Descriptions.Item label="邮箱">
            {data.email !== "NULL" ? data.email : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="项目Key">
            <Text copyable>{data.project_key}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="环境ID">{data.en_id}</Descriptions.Item>
          <Descriptions.Item label="会话ID">{data.chat_id}</Descriptions.Item>
          <Descriptions.Item label="创建时间">
            {new Date(data.created_at).toLocaleString("zh-CN")}
          </Descriptions.Item>
          <Descriptions.Item label="更新时间">
            {new Date(data.updated_at).toLocaleString("zh-CN")}
          </Descriptions.Item>
        </Descriptions>

        <AntTitle level={5}>对话内容</AntTitle>
        <div
          style={{
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
            background: "#fafafa",
            padding: "16px",
          }}
        >
          {data.message?.messages && data.message.messages.length > 0 ? (
            renderChatMessages(data.message.messages)
          ) : (
            <Empty description="暂无对话内容" />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ChatDetailModal;
